module.exports = __webpack_public_path__ + "img/circles-bg.99501140.svg";